import angular from "angular";
import JSZip from "@progress/jszip-esm";
import { saveAs } from "file-saver";
import { Ajax, Configs, Translations, Texts, Dates, Reports } from "@salaxy/core";
import { UiHelpers } from "../../services";

/**
 * Provides functionality to export salary slip(s) as pdf or zipped pdf.
 */
export class SalarySlipDownloadController implements angular.IController {
  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "$http",
    "AjaxNg1",
    "UiHelpers",
    "Reports"
  ];

  constructor(
    private $http: angular.IHttpService,
    private ajax: Ajax,
    private uiHelpers: UiHelpers,
    private reportsApi: Reports
  ) {}

  /**
   * Export items
   * One item is exported as pdf and multiple items are exported as zip containg pdfs.
   */
  public async export(items: any[]) {
    const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    const promises = items.map(x => {
      const url = `${Configs.current.apiServer}/v03/api/reports/assure-pdf/salarySlip?language=${encodeURIComponent(Translations.getLanguage())}&ids=${x.id}&disposition=inline&access_token=${this.ajax.getCurrentToken()}`;
      return this.ajax.getBlob(url);
    });
    const responses = await Promise.all(promises);
    if(responses.length === 1) {
      this.uiHelpers.downloadFile(responses[0].data as any, decodeURIComponent(responses[0].headers["content-disposition"]).match(/filename\s*=\s*"?(?<file>.*?)(?:\s*;|"|\s*$)/)?.groups?.file);
      loading.dismiss();
    } else {
      const zip = new JSZip();
      const fileNames = {};
      responses.forEach(response => {
        const fileName = `${decodeURIComponent(response.headers["content-disposition"]).match(/filename\s*=\s*"?(?<file>.*?)(?:\s*;|"|\s*$)/)?.groups?.file}`;
        if(Object.keys(fileNames).includes(fileName)) {
          ++fileNames[fileName];
          zip.file(`${fileNames[fileName]}_${fileName}`, response.data as Blob);
        } else {
          fileNames[fileName] = 1;
          zip.file(fileName, response.data as Blob);
        }
      });
      const zipBlob = await zip.generateAsync({type: "blob", mimeType: "application/zip"});
      saveAs(zipBlob, Texts.escapeFileName(`${Translations.get("SALAXY.UI_Terms.downLoadableMaterialTypes.calculations")}_${Dates.format("today","YYYYMMDD")}`));
      loading.dismiss();
    }
  }
}
